export default {
  data() {
    return {
      currentCountry: window.Phoenix.currentCountry,
    };
  },

  methods: {
    localizePrice(price) {
      if (this.currentCountry && price?.[this.currentCountry]) {
        return price[this.currentCountry];
      }

      return '';
    },

    vatInformation(price) {
      if (this.currentCountry && price?.[this.currentCountry]) {
        return price[this.currentCountry].vatInformation;
      }

      return '';
    },
  },
};
